<app-modal-template
	[title]="'Download Permissions'"
	(cancelClicked)="cancel()"
	(saveClicked)="downloadFile()"
	[showCancel]="false"
	[saveText]="'Download'"
	[saveIcon]="['fass', 'arrow-to-bottom']"
>
	<p>Click the button below to download a list of permissions in .CSV format.</p>
</app-modal-template>
